import { getBrandList } from '@this/services/config';
import sampleSize from 'lodash/sampleSize';
import localStorage from '@/utils/localStorage';
const state = {
  allBrandList: [],
  prizePicture: '',
  carPicture: '',
};

const mutations = {
  setAllBrandList(state, list) {
    state.allBrandList = list;
  },
  setPrizePicture(state, string) {
    state.prizePicture = string;
  },
  setCarPicture(state, string) {
    state.carPicture = string;
  },
};

const getters = {
  brandList(state, getters, rootState) {
    const { allBrandList } = state;
    const { city } = rootState.city;
    let brandList = [];
    brandList = allBrandList.filter((item, index) => {
      if (item.city.indexOf(city.name) > -1 || !item.city) {
        return item;
      }
    });
    return brandList;
  },
  brandCar(state, getters, rootState) {
    const { brandList } = getters;
    let brandCar = [];
    brandCar = brandList.filter((item, index) => {
      if (item.id !== 999) {
        return item;
      }
    });
    return brandCar;
  },
  cardImg(state, getters, rootState) {
    const { brandList } = getters;
    const cards = rootState.user.cards;
    let cardList = [];
    let currentBrand = {};
    for (let i = 0; i < cards.length; i++) {
      currentBrand = brandList.find((item) => cards[i] == item.id);
      if (currentBrand) {
        let obj = {};
        obj.id = cards[i];
        obj.brandImg = currentBrand.brand_img;
        cardList.push(obj);
      }
    }
    return cardList;
  },
  allCard(state, getters, rootState) {
    const { cardImg } = getters;
    const cardLength = cardImg.length;
    if (cardLength < 5) {
      for (let i = 0; i < 5 - cardLength; i++) {
        cardImg.push({ brandImg: 'https://w-cdn.pangku.com/uploads/alipay/default/2020121017101100341658156366.png' });
      }
    }
    return cardImg;
  },
};

const actions = {
  // 获取品牌id
  getBrand({ commit, dispatch }) {
    return getBrandList().then((res) => {
      const brandList = res.data;
      commit('setAllBrandList', brandList);
    });
  },
  getCards({ commit, rootState }) {
    const {
      user: { userInfo },
    } = rootState;
    let cards = userInfo.cards;
    commit('user/setCards', cards, { root: true });
  },
  getPrizePicture({ commit, getters }) {
    const { brandCar } = getters;
    const brandInfo = sampleSize(brandCar, 1);
    commit('setPrizePicture', brandInfo[0].luck_img);
  },
  // 品牌车图
  getCarImg({ commit, getters }) {
    const { brandCar } = getters;
    const brandInfo = sampleSize(brandCar, 1);
    commit('setCarPicture', brandInfo[0].car_img);
  },
  getSharePicture({ getters }) {
    const { brandCar } = getters;
    const brandInfo = sampleSize(brandCar, 1);
    localStorage.set('shareImg', brandInfo[0].share_img);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
